import { STATUS_INTENT_TOKENS } from '@apps/web/components/ui/status_tokens';
import { type WorkforceMapPoint } from '@libraries/typescript/api_client';

export const AVAILABILITY_MAP_STYLES: Record<
    WorkforceMapPoint['availability_status'],
    {
        readonly color: string;
        readonly label: string;
        readonly dotColor: string;
    }
> = {
    available: {
        color: '#00bc7d',
        dotColor: STATUS_INTENT_TOKENS.positive.dot,
        label: 'Available now',
    },
    scheduled: {
        color: '#fe9a00',
        dotColor: STATUS_INTENT_TOKENS.warning.dot,
        label: 'On shift (scheduled)',
    },
    unavailable: {
        color: '#ff2056',
        dotColor: STATUS_INTENT_TOKENS.negative.dot,
        label: 'Unavailable now',
    },
    unknown: {
        color: '#90a1b9',
        dotColor: STATUS_INTENT_TOKENS.neutral.dot,
        label: 'Availability unknown',
    },
};

export const CLIENT_MARKER_COLOR = '#5533ee';
export const OPEN_SHIFT_CLIENT_MARKER_COLOR = '#ff2056';
export const CLIENT_MARKER_BACKGROUND = '#eeeafd';
